import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {ProductCollection} from 'types/product-collection';
import {ResponseData} from 'types/response-data';
import queryParams from 'utils/query-params';

const getPricingProductTotals = api.injectEndpoints({
  endpoints: builder => ({
    getPricingProductTotals: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `prices/pricing-query-totals`,
          params: queryParams(params, '|'),
        };
      },
    }),
  }),
});

type Request = {};

type Response = ResponseData<{
  marge_avg: number;
  sales_count: number;
  benefits: number;
  revenue: number;
  situation_cost_ht_sum: number;
  export_catalog_link: string;
}>;

export const {useGetPricingProductTotalsQuery} = getPricingProductTotals;
